import React, { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import {
  defaultFormValues,
  IMealCreditFormFields,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export const MealCreditFormProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const methods = useForm<IMealCreditFormFields>({
    mode: 'all',
    defaultValues: defaultFormValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
